// Importing components
import { FormElems, Description } from 'components';

// Importing constant
import { MAX_25MB, POPUP_ENUM } from '../../utils/constants/commonValues';
import { DEFEND_TRANSACTION_INFO_ENUM } from './constant';

// Importing Libraries
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import './defendChargebackForm.scss';

const DefendChargebackForm = ({
    handleSubmit,
    onClose,
    onSubmit,
    subChargebackDetails,
    transactionData,
}) => {
    const [fileList, setFileList] = useState([]);

    const transactionDescriptionData =
        transactionData &&
        DEFEND_TRANSACTION_INFO_ENUM.map(item => {
            return { ...item, children: transactionData[item.key] };
        });

    const handleChargeBackExtensionSubmit = values => {
        onSubmit(POPUP_ENUM.CHARGEBACK_DEFEND, values);
    };

    return (
        <form
            className="defend-chargeback-form"
            onSubmit={handleSubmit(handleChargeBackExtensionSubmit)}
        >
            <Description items={transactionDescriptionData} />
            <div className="separator" />
            <div className="form-field ">
                <Field
                    wrapperClass="comment-input"
                    name="remarks"
                    type="textarea"
                    isDisabled={false}
                    component={FormElems.TextArea}
                    placeholder="Remarks"
                />
            </div>
            <div className="form-field ">
                <Field
                    name="files"
                    type="file"
                    onFileListChange={files => setFileList(files)}
                    fileList={fileList}
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .jpeg, .png, .gif, .zip, .rar, .7zip"
                    subtitle="Maximum file size 25MB. Only PDF, doc, excel, .zip and image files are accepted"
                    component={FormElems.MultiUpload}
                    maxSize={MAX_25MB}
                />
            </div>
            <div className="form-section-actions">
                <FormElems.Button
                    buttonType="secondary"
                    id="back-btn"
                    text="Cancel"
                    type="button"
                    handleClick={onClose}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="Submit"
                />
            </div>
        </form>
    );
};

const mapStateToProps = ({ form }) => ({
    formData: form['defend-chargeback-form'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

export default compose(
    reduxForm({
        form: 'defend-chargeback-form',
        enableReinitialize: true,
        validate: () => {},
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(DefendChargebackForm);

// PropType validation for UpdateChargeBackStatusForm component
DefendChargebackForm.propTypes = {
    formData: PropTypes.object,
    onClose: PropTypes.func,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    subChargebackDetails: PropTypes.object,
    transactionData: PropTypes.object,
};
